















































































import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import DatePicker from 'ss-commons-front/src/components/DatePicker.vue';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { Event } from '../models/event';

dayjs.extend(utc);

@Component({
  components: {
    DatePicker,
  },
})
export default class EventFilter extends Vue {
  @Prop({ required: true })
  events!: Array<Event>;

  filteredEvents: Event[] = this.events;

  filterType: string = 'name';

  filterValue: string | Array<string | null> = '';

  filters = {
    name: (value: string) =>
      value !== ''
        ? this.events.filter((event: Event) => event.info.name.toLowerCase().includes(value.toLowerCase()))
        : this.events,

    period: (values: string[]) =>
      (values[0] &&
        values[1] &&
        this.events.filter(
          (event: Event) =>
            dayjs.utc(values[0]).toDate() <= dayjs.utc(event.info.dates[0].start).toDate() &&
            dayjs.utc(`${values[1]} 23:59:59`).toDate() >=
              dayjs.utc(event.info.dates[event.info.dates.length - 1].end).toDate(),
        )) ||
      (values[0] &&
        this.events.filter(
          (event: Event) => dayjs.utc(values[0]).toDate() <= dayjs.utc(event.info.dates[0].start).toDate(),
        )) ||
      (values[1] &&
        this.events.filter(
          (event: Event) =>
            dayjs.utc(values[1]).endOf('day').toDate() >=
            dayjs.utc(event.info.dates[event.info.dates.length - 1].end).toDate(),
        )) ||
      this.events,

    free: () => this.events.filter((event: Event) => event.info.price === 0),

    paid: (value: string) =>
      (value !== '' &&
        this.events.filter((event: Event) => event.info.price <= Number.parseFloat(value) && event.info.price > 0)) ||
      this.events.filter((event: Event) => event.info.price > 0),

    coordinator: (value: string) =>
      (value !== '' &&
        this.events.filter((event: Event) => event.organizer.name.toLowerCase().includes(value.toLowerCase()))) ||
      this.events,

    instructor: (value: string) =>
      (value !== '' &&
        this.events.filter((event: Event) =>
          event.subEvents.find((subEvent) => subEvent.info.sub_title.toLowerCase().includes(value.toLowerCase())),
        )) ||
      this.events.filter((event: Event) => event.subEvents.length !== 0),
  };

  callFilter() {
    this.filteredEvents = this.filters[this.filterType](this.filterValue);
  }

  resetFilter() {
    this.filterType === 'period' ? (this.filterValue = [null, null]) : (this.filterValue = '');
  }

  clearFilter() {
    this.filterType = 'name';
    this.resetFilter();
    this.filteredEvents = this.events;
  }

  @Watch('filteredEvents', { immediate: true })
  onFilteredEventsChange() {
    this.$emit('filter-event', this.filteredEvents);
  }
}
